import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@app-store/store'
import loadable from '@loadable/component'

const IncomingMeetingRequestModal = loadable(() => import('@modals/IncomingMeetingRequestModal'))
const OutgoingMeetingRequestModal = loadable(() => import('@modals/OutgoingMeetingRequestModal'))
const MomentumModal = loadable(() => import('@modals/Momentum'))
const SurveyModal = loadable(() => import('@modals/Survey'))
const ServiceViewModal = loadable(() => import('@modals/ServiceViewModal'))

const GlobalModalsProvider = () => {
    const { incomingMeetingRequests, outgoingMeetingRequests, survey, momentum, crmIntegration } = useSelector(
        (store: RootState) => store.ui
    )

    return (
        <>
            {incomingMeetingRequests.infoModal.isOpen && <IncomingMeetingRequestModal />}
            {outgoingMeetingRequests.infoModal.isOpen && <OutgoingMeetingRequestModal />}
            {momentum.isOpen && <MomentumModal />}
            {survey.isOpen && <SurveyModal />}
            {crmIntegration.serviceViewModal.isOpen && <ServiceViewModal />}
        </>
    )
}

export default GlobalModalsProvider
